var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-box" },
    [
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.sortedPickUpInfo,
            border: "",
            "max-height": "400px",
            size: "mini",
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "订单编号", align: "center", width: "250" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.ferryOrderDetails(scope.row)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.orderNo) +
                            "\n        "
                        ),
                      ]
                    ),
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content: "复制",
                          placement: "right-start",
                        },
                      },
                      [
                        _c("el-button", {
                          attrs: {
                            icon: "el-icon-document-copy",
                            circle: "",
                            size: "mini",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.copyOrderNo(scope.row.orderNo)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "出发地",
              align: "center",
              prop: "departureAddress",
              width: "180",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("yd-link", {
                      attrs: {
                        value: row.departureAddress,
                        type: "location",
                        query: {
                          longitude: row.startLongitude,
                          latitude: row.startLatitude,
                          name: row.departureAddress,
                          lineName: _vm.info.lineName,
                        },
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "目的地",
              align: "center",
              prop: "destinationAddress",
              width: "180",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("yd-link", {
                      attrs: {
                        value: row.destinationAddress,
                        type: "location",
                        query: {
                          longitude: row.endLongitude,
                          latitude: row.endLatitude,
                          name: row.destinationAddress,
                          lineName: _vm.info.lineName,
                        },
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "接送类型",
              align: "center",
              prop: "pickupType",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        "\n          " +
                          _vm._s(scope.row.pickupType) +
                          "（" +
                          _vm._s(scope.row.ferryPriceType === 2 ? "专" : "拼") +
                          "）\n        "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "接送方式", align: "center", prop: "pickupWay" },
          }),
          _c("el-table-column", {
            attrs: { label: "状态", align: "center", prop: "status" },
          }),
          _c("el-table-column", {
            attrs: {
              label: "支付金额（元）",
              align: "center",
              prop: "payAmount",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "剩余金额（元）",
              align: "center",
              prop: "surplusAmount",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "司机信息", align: "center", prop: "driverMsg" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("yd-link", {
                      attrs: {
                        permi: "driver_data_normal",
                        value:
                          row.driverMsg && row.driverMsg !== "-"
                            ? row.driverMsg
                            : "",
                        url:
                          "/data-analysis/driver-data/normal/detail/" +
                          row.driverId,
                        type: "userInfo",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "车辆信息", align: "center", prop: "carMsg" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("yd-link", {
                      attrs: {
                        permi: "vehicle_view",
                        value:
                          row.carMsg && row.carMsg !== "-" ? row.carMsg : "",
                        type: "vehicleDetail",
                        query: { id: row.carId },
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }